export default {
      id: "ic-decrease-usage",
      viewBox: "0 0 23 12",
      url: "/" + "images/icons.3.109.2.svg#ic-decrease-usage",
      toString: function () {
        return this.url;
      }
    }